import api from '@/api';
const job = {
    // 获取所有工作地点
    getAllArea: async() => {
        const res = await api.area.listAllArea();
        if (res.code !== 200) {
            return [];
        }
        return res.data;
    },
    // 获取所有工作地点
    getAllPostType: async() => {
        const res = await api.postType.listPostTypes();
        if (res.code !== 200) {
            return [];
        }
        return res.data;
    },
    // 获取所属公司
    getAllOrg: async() => {
        const res = await api.org.listAllOrg();
        if (res.code !== 200) {
            return [];
        }
        return res.data;
    },
    async getPostListByParams(pageNum, pageSize, recruitmentFaceToType, postTypeId, areaId, orgId, postName, postList) {
        const res = await api.post.getPostListByParams(pageNum, pageSize, recruitmentFaceToType, postTypeId, areaId, orgId, postName, postList);
        if (res.code !== 200) {
            return { data: [], total: 0 };
        }
        return res.data;
    }
};
export default job;
